import { Component, ElementRef, EventEmitter, Input, Output, inject, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { lastValueFrom } from 'rxjs';
import { CampaignsCampaignAdminApiClient } from 'src/app/api/api-campaigns.service.generated';
import { GUID } from 'src/app/common/utils/GuidUtils';
import { S3Upload } from 'src/app/common/utils/S3Upload';
import { PhotoComponent } from 'wecheer-common';

@Component({
  selector: 'app-campaign-banner-image',
  templateUrl: './campaign-banner-image.component.html',
  styleUrls: ['./campaign-banner-image.component.scss'],
  imports: [
    PhotoComponent,
    MatIconModule
  ]
})
export class CampaignBannerImageComponent {
  private campaignsApi = inject(CampaignsCampaignAdminApiClient);
  private snackBar = inject(MatSnackBar);


  @Input() editable: boolean = true;
  @Input() banner: BannerImage;
  @Input() maxSize: number | null;
  @Output() bannerUploaded = new EventEmitter<BannerImage>();

  readonly fileInputBanner = viewChild<ElementRef>('fileInputBanner');

  ALLOWED_EXTENSIONS_BANNER = ['jpg', 'jpeg', 'png', 'gif'];


  async onBannerImageSelected(event) {
    if (!this.editable) {
      return;
    }
    try {
      const file = event.target.files[0];
      if (!file || !this.isValidBanner(file)) {
        this.snackBar.open('Invalid image file', 'Dismiss', { duration: 2000 });
        return;
      }

      if (this.maxSize && file?.size > this.maxSize) {
        this.snackBar.open('Image file size should not greater than 2MB', 'Dismiss', { duration: 2000 });
        this.fileInputBanner().nativeElement.value = '';
        return;
      }

      if (!this.banner)
        this.banner = new BannerImage();

      this.banner.uploadKey = GUID.newGuid().replace(/-/g, '') + '.' + file.name.split('.').pop(); // preserve extension on s3 key
      const uploadUrl = await lastValueFrom(this.campaignsApi.getUploadUrl(this.banner.uploadKey));
      const uploadSuccess = await lastValueFrom(S3Upload.upload(uploadUrl, file));
      if (uploadSuccess) {
        const parts = uploadUrl.split('?');
        const photoBannerUrl = parts[0];
        this.banner.photoUrl = photoBannerUrl.replace('s3.ap-southeast-1.amazonaws.com/', ''); // trim s3 part to get photo using cloudfront

        this.bannerUploaded.emit(this.banner);
      }

    } catch (err) {
      console.error('upload failed', err);
    }
  }

  isValidBanner(file: File): boolean {
    return file.name && this.ALLOWED_EXTENSIONS_BANNER.filter(e => file.name.trim().toLowerCase().endsWith(e)).length > 0;
  }
}

export class BannerImage {
  photoUrl?: string;
  uploadKey?: string;

  constructor(data?: BannerImage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}
